export const RootLevelResources = {
	'athlete': true,
	'action': true,
	'bestAthletesEvent': true,
	'baEventAttendee': true,
	'baEventOrder': true,
	'baEventWaiver': true,
	'coach': true,
	'course': true,
	'student': true,
	'depthChart': true,
	'discussion': true,
	'comment': true,
	'featureFlag': true,
	'file': true,
	'notification': true,
	'user': true,
	'search': true,
	'team': true,
	'organization': true,
	'organizationPlayer': true,
	'calendar': true,
	'calendarEvent': true,
	'fileRecord': true,
	'event': true,
	'sourceVideoMux': true,
	'markupTagClipMux': true,
	'videoClipCategories': true,
	'athleteAssessmentData': true,
	'spqData': true,
	'selfAssessment': true,
	'uniqueToken': true,
	'statistic': true,
	'video': true,
	'videoClip': true,
	'customer': true,
	'paymentMethod': true,
	'product': true,
	'subscription': true,
	'subscription-plan': true,
	'school': true,
	'scouting-report': true,
	'targetedSharing': true,
	'viewRecord': true,
	'favouriteList': true,
	'gameResult': true,
	'userPreference': true,
};
export const RESOURCES = Object.keys(RootLevelResources);
export type HinderResource = keyof typeof RootLevelResources;